import { render, staticRenderFns } from "./ModalConfirmRequirePaper.vue?vue&type=template&id=770cd127&scoped=true"
import script from "./ModalConfirmRequirePaper.vue?vue&type=script&lang=js"
export * from "./ModalConfirmRequirePaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cd127",
  null
  
)

export default component.exports